let activeCode: string | null = null;

export const setActiveRemittanceOrder = (code: string): void => {
  activeCode = code;
};

export const clearActiveRemittanceOrder = (): void => {
  activeCode = null;
};

export const getActiveRemittanceOrder = (): string | null => activeCode;

export const cancelActiveRemittanceOrder = async (): Promise<void> => {
  const code = activeCode;
  if (!code) return;
  activeCode = null;
  try {
    const { cancelRemittancePayment } = await import('@shared/services/api/remittancesService');
    await cancelRemittancePayment(code);
  } catch {
    // Best-effort cleanup — never block or fail the logout on this.
  }
};

export const _resetActiveRemittanceOrder = (): void => {
  activeCode = null;
};
